import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { OAISchema } from '~/types/openapi';

// ============================================================================
// Response 타입 (export for use in components)
// ============================================================================

/** 약관 조회 응답 타입 */
export type TermsResponseDTO = OAISchema['FrontCnidTermsResponse'];

/** 약관 번들 타입 */
export type TermsRootDTO = OAISchema['FrontCnidTermsRoot'];

/** 개별 약관 타입 */
export type MarketTermsDTO = OAISchema['MarketTermsResponse'];

/** 약관 동의 요청 타입 */
export type AgreeTermsRequestDTO = OAISchema['AgreeTermsRequest'];

// ============================================================================
// DataSource Interface & Implementation
// ============================================================================

export interface TermsDataSource {
  /** 약관 조회 */
  getTerms(bundleId: string): Promise<TermsResponseDTO>;
  /** 주소 등록 약관 조회 */
  getAddressTerms(): Promise<TermsResponseDTO>;
  /** 약관 동의 */
  agreeTerms(request: AgreeTermsRequestDTO): Promise<void>;
}

export class TermsDataSourceImpl implements TermsDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getTerms(bundleId: string) {
    return this.client.request<TermsResponseDTO>({
      url: '/api/market-place/v2/terms',
      method: 'get',
      params: { bundleId },
    });
  }

  async getAddressTerms() {
    return this.client.request<TermsResponseDTO>({
      url: '/api/market-place/v2/terms/address',
      method: 'get',
    });
  }

  async agreeTerms(request: AgreeTermsRequestDTO) {
    return this.client.request<void>({
      url: '/api/market-place/v2/terms/agree',
      method: 'post',
      data: request,
    });
  }
}

export const termsDataSource = new TermsDataSourceImpl();
